var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLUE_500, InfoIcon, InfoTag, Tooltip, Typography, getTestId, tokens, useBreakpoint } from '@airtel/air-design-system';
import { useState } from 'react';
import { Pressable, View } from 'react-native';
import { getPriceDiscountStyles } from './PriceDiscountStyles';
var RightPriceSection = props => {
  var _props$showInfoIcon = props.showInfoIcon,
    showInfoIcon = _props$showInfoIcon === void 0 ? false : _props$showInfoIcon,
    infoIconTooltipProps = props.infoIconTooltipProps,
    showInfoTag = props.showInfoTag,
    infoTagProps = props.infoTagProps,
    rowAlignmentDirection = props.rowAlignmentDirection,
    testID = props.testID,
    restRightProps = __rest(props, ["showInfoIcon", "infoIconTooltipProps", "showInfoTag", "infoTagProps", "rowAlignmentDirection", "testID"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var priceDiscountStyles = getPriceDiscountStyles(rowAlignmentDirection, isLargeScreen);
  var _useState = useState(false),
    showToolTip = _useState[0],
    setShowTooltip = _useState[1];
  var onInfoIconPress = () => {
    if (!showToolTip) {
      setShowTooltip(!showToolTip);
    }
  };
  return _jsxs(View, Object.assign({
    style: [priceDiscountStyles === null || priceDiscountStyles === void 0 ? void 0 : priceDiscountStyles.rightPriceSectionStyle]
  }, {
    children: [_jsx(Typography, Object.assign({}, getTestId(testID, 'price'), {
      style: priceDiscountStyles === null || priceDiscountStyles === void 0 ? void 0 : priceDiscountStyles.priceTypography
    }, restRightProps)), showInfoTag && _jsx(InfoTag, Object.assign({}, infoTagProps, getTestId(testID, 'infoTag'))), showInfoIcon && _jsx(Tooltip, Object.assign({
      isVisible: showToolTip,
      position: isLargeScreen ? 'bottom-start' : 'bottom-center',
      onClose: () => {
        if (infoIconTooltipProps === null || infoIconTooltipProps === void 0 ? void 0 : infoIconTooltipProps.autoHide) {
          setShowTooltip(false);
        }
      },
      offset: {
        center: 2,
        y: -6,
        start: -10
      }
    }, infoIconTooltipProps, getTestId(testID, 'tooltip'), {
      children: _jsx(Pressable, Object.assign({
        onPress: onInfoIconPress
      }, {
        children: _jsx(InfoIcon, Object.assign({
          color: BLUE_500,
          style: priceDiscountStyles.infoIcon,
          fontSize: tokens.spacing.SPACING_16
        }, getTestId(testID, 'infoIcon')))
      }))
    }))]
  }));
};
var PriceDiscount = _ref => {
  var priceDiscount = _ref.priceDiscount,
    style = _ref.style,
    testID = _ref.testID,
    rowAlignmentDirection = _ref.rowAlignmentDirection;
  var _useBreakpoint2 = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint2.isLargeScreen;
  var priceDiscountStyles = getPriceDiscountStyles(rowAlignmentDirection, isLargeScreen);
  return _jsx(View, Object.assign({
    style: style
  }, getTestId(testID, 'container'), {
    children: priceDiscount === null || priceDiscount === void 0 ? void 0 : priceDiscount.map((priceInfo, idx) => {
      var left = priceInfo.left,
        right = priceInfo.right;
      return _jsxs(View, Object.assign({
        style: [idx == (priceDiscount === null || priceDiscount === void 0 ? void 0 : priceDiscount.length) - 1 ? priceDiscountStyles === null || priceDiscountStyles === void 0 ? void 0 : priceDiscountStyles.discountedPrice : priceDiscountStyles === null || priceDiscountStyles === void 0 ? void 0 : priceDiscountStyles.priceBreakUp]
      }, {
        children: [_jsx(View, Object.assign({
          style: priceDiscountStyles.leftTypographyContainer
        }, {
          children: _jsx(Typography, Object.assign({}, getTestId(testID + '_leftSection', idx === null || idx === void 0 ? void 0 : idx.toString()), left))
        })), _jsx(View, Object.assign({
          style: [priceDiscountStyles === null || priceDiscountStyles === void 0 ? void 0 : priceDiscountStyles.rightTypoGraphyContainer]
        }, {
          children: _jsx(RightPriceSection, Object.assign({}, right, {
            rowAlignmentDirection: rowAlignmentDirection
          }, getTestId(testID + '_rightSection', idx === null || idx === void 0 ? void 0 : idx.toString())))
        }))]
      }), "price_info_" + idx);
    })
  }));
};
export default PriceDiscount;